import React, { useState } from "react";
import { Edit3, Trash2 } from "react-feather";

import { Textarea } from "@/Components/Form";

export function FactorGasComment({
  gas = {},
  isDisabled = false,
  onFormUpdate = (_) => {},
  setCommentVisible = (_) => {},
}) {
  const [isEditingComment, setIsEditingComment] = useState(false);

  const [gasSnapshot] = useState({ ...gas });

  function handleUpdate(e) {
    onFormUpdate(e);
  }

  return (
    <>
      {isEditingComment ? (
        <div className="relative my-4 w-full md:mr-12">
          <Textarea
            name="comment"
            value={gas?.comment}
            onChange={handleUpdate}
            className="bg-[#F6F6F6 min-h-[108px]"
            placeholder="Add your comment here"
          />
          <div className="absolute top-3 bottom-3 right-4 flex flex-col items-end justify-between">
            <button
              className="hover-circle relative z-10 h-5 w-5"
              onClick={() => {
                setIsEditingComment(false);
                setCommentVisible(false);
                handleUpdate({ target: { name: "comment", value: null } });
              }}
            >
              <Trash2 size={20} />
            </button>
            <div>
              <button
                className="text-blue underline hover:no-underline"
                onClick={() => {
                  setIsEditingComment(false);
                  handleUpdate({
                    target: {
                      name: "comment",
                      value: gasSnapshot?.comment || "",
                    },
                  });
                }}
              >
                Cancel
              </button>
              <button
                className="ml-4 font-bold text-blue underline hover:no-underline"
                onClick={() => {
                  setIsEditingComment(false);
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="my-4 flex w-full cursor-pointer justify-between border border-borderColor py-3 px-4 md:mr-12"
          onClick={() => setIsEditingComment(true)}
        >
          <p>
            {gas?.comment ? (
              gas.comment
            ) : (
              <span className="select-none text-typo-inactive">
                Add your comment here
              </span>
            )}
          </p>

          {!isDisabled && (
            <button
              className="hover-circle relative z-10 h-5 w-5"
              onClick={() => setIsEditingComment(true)}
            >
              <Edit3 size={20} />
            </button>
          )}
        </div>
      )}
    </>
  );
}
